import orderBy from 'lodash.orderby';
import { isDefined, isUndefined } from '../../../utils/isDefined';

const mapNumberRanges = (externalNo, mappedMitelData) => {
  return externalNo.map(range => {
    const numbersToCheck = createNumbersArray(
      Number(range.range_from),
      Number(range.range_up_to_incl)
    );
    const mappedNumbers = numbersToCheck.reduce((obj, number) => {
      const founded = findMitelRange(mappedMitelData, number);

      if (isUndefined(founded)) {
        return obj;
      }

      return {
        assigned: isDefined(obj?.assigned)
          ? [...orderBy([...obj.assigned, ...founded.assigned], 'number')]
          : [...founded.assigned],
        unassigned: isDefined(obj?.unassigned)
          ? [...orderBy([...obj.unassigned, ...founded.unassigned], 'number')]
          : [...founded.unassigned],
        all: isDefined(obj.all)
          ? [...orderBy([...obj?.all, ...founded.all], 'number')]
          : [...founded.all]
      };
    }, {});

    return {
      ...range,
      mitelData: Object.keys(mappedNumbers).length > 0 ? mappedNumbers : void 0
    };
  });
};

export default mapNumberRanges;

const findMitelRange = (mappedMitelData, number) => {
  const foundedRange = mappedMitelData.find(
    range =>
      Number(number) >= Number(range.rangeFrom) &&
      Number(number) <= Number(range.rangeTo)
  );

  if (isUndefined(foundedRange)) {
    return null;
  }

  return {
    ...foundedRange,
    all: mapFoundedRangeNumbers(foundedRange.all, number),
    assigned: mapFoundedRangeNumbers(foundedRange.assigned, number),
    unassigned: mapFoundedRangeNumbers(foundedRange.unassigned, number),
    filteredNumber: true
  };
};

const mapFoundedRangeNumbers = (rangeNumbers, number = {}) => {
  if (isUndefined(rangeNumbers) || isUndefined(number)) {
    return [];
  }

  return rangeNumbers
    .map(rangeNumber => {
      if (
        Number(rangeNumber.number.replace('+', '').trim()) === Number(number)
      ) {
        return { ...rangeNumber, founded: true };
      }

      return { ...rangeNumber };
    })
    .filter(el => el.founded)
    .map(el => {
      const { founded, ...rest } = el;
      return rest;
    });
};

const createNumbersArray = (from, to) => {
  let numbersToCheck = [];

  for (let i = from; i <= to; i++) {
    numbersToCheck = [...numbersToCheck, i];
  }

  return numbersToCheck;
};
